export const iconFontAwesomeTransportationAccessibleIcon = (
	<i className="fa-solid fa-accessible-icon"></i>
);
